const vi = {
  100000001:'Thông tin chính',
  100000002:'Tên token',
  100000003:'Người tạo bản sao',
  100000004:'Thời gian tạo phiên bản',
  100000005:'Thông tin cơ bản',
  100000006:'Chuỗi khối/giao thức liên quan  ',
  100000007:'Địa chỉ hợp đồng thông minh  ',
  100000008:'Ngày phát hành',
  100000009:'Tổng cung',
  100000010:'Cung lưu hành',
  100000011:'Giá trị thị trường',
  100000012:'Thông tin',
  100000013:'Thông tin truyền thông xã hội',
  100000014:'Trang web',
  100000015:'White Paper',
  100000016:'Trình duyệt blockchain  ',
  100000017:'Đánh giá dự án',
  100000018:'Xếp hạng',
  100000019:'hàng đầu',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'Đã cập nhật thời gian',
  100000027:'Đánh giá an toàn  ',
  100000028:'Đánh giá an toàn hợp đồng  ',
  100000029:'Thống kê dự án rủi ro  ',
  100000030:'Chi tiết mã hợp đồng  ',
  100000031:'Thuế mua  ',
  100000032:'Thuế bán  ',
  100000033:'Là bẫy mật  ',
  100000034:'Có thể mint lại  ',
  100000035:'Có danh sách đen  ',
  100000036:'Có danh sách trắng  ',
  100000037:'Có chống cá voi  ',
  100000038:'Có thể thay đổi thuế suất  ',
  100000039:'Mã nguồn mở  ',
  100000040:'Có chủ sở hữu ẩn  ',
  100000041:'Có thể tự hủy  ',
  100000042:'Là hợp đồng đại diện  ',
  100000043:'Có thể thay đổi số dư  ',
  100000044:'Có thể thực hiện cuộc gọi bên ngoài  ',
  100000045:'Có thể lấy lại quyền sở hữu  ',
  100000046:'Có thời gian chờ cho giao dịch  ',
  100000047:'Có thể tạm dừng chuyển khoản  ',
  100000048:'Quyền sở hữu không bị từ bỏ  ',
  100000049:'Là chống cá voi có thể điều chỉnh  ',
  100000050:'Quá nhiều chữ số thập phân  ',
  100000051:'Phương pháp Mint và Burn công khai  ',
  100000052:'Đốt token cập nhật tổng cung  ',
  100000053:'Đốt token cập nhật số dư   ',
  100000054:'Chuyển khoản cho chính mình làm tăng số dư  ',
  100000055:'Chuyển token vượt quá số dư sẽ bị vô hiệu  ',
  100000056:'Số dư không được cập nhật trong khi chuyển  ',
  100000057:'Sẽ tiêu tốn số dư của người nhận  ',
  100000058:'Gọi TransferFrom vượt quá số dư sẽ thất bại  ',
  100000059:'Phương pháp BurnFrom cập nhật tổng cung  ',
  100000060:'Xác định thuế mua của token. Trên 5% được coi là mức thuế cao',
  100000061:'Xác định thuế bán của token. Trên 5% được coi là mức thuế cao',
  100000062:'Kiểm tra xem token có phải là một trò lừa đảo honeypot không',
  100000063:'Kiểm tra xem có thể tạo thêm token không',
  100000064:'Kiểm tra xem token có danh sách đen hạn chế người dùng trao đổi hoặc chuyển token không',
  100000065:'Kiểm tra xem token có danh sách trắng cho phép địa chỉ bỏ qua mọi hạn chế không',
  100000066:'Kiểm tra xem token có cơ chế chống cá voi không',
  100000067:'Kiểm tra xem token có thuế và thuế có thể được sửa đổi bởi các vai trò đặc quyền không',
  100000068:'Kiểm tra xem token đã được xác minh trên trình khám phá blockchain chưa',
  100000069:'Kiểm tra xem token có chủ sở hữu ẩn có thể thao túng hợp đồng, ngay cả khi quyền sở hữu dường như đã bị từ bỏ không',
  100000070:'Kiểm tra xem token có thể tự hủy không',
  100000071:'Kiểm tra xem token có phải là hợp đồng ủy quyền chuyển tiếp các cuộc gọi chức năng đến một hợp đồng thực thi không',
  100000072:'Kiểm tra xem số dư token có thể được sửa đổi bởi các vai trò đặc quyền không',
  100000073:'Kiểm tra xem token có gọi các hợp đồng bên ngoài không',
  100000074:'Kiểm tra xem token có cửa hậu để lấy lại quyền sở hữu không',
  100000075:'Kiểm tra xem token có cơ chế thời gian chờ chuyển không',
  100000076:'Kiểm tra xem giao dịch token có thể bị tạm dừng bởi các vai trò đặc quyền không',
  100000077:'Kiểm tra xem quyền sở hữu đã bị từ bỏ chưa',
  100000078:'Kiểm tra xem cơ chế chống cá voi của token có thể được sửa đổi bởi các vai trò đặc quyền không',
  100000079:'Kiểm tra xem giá trị trả về của hàm decimals() có lớn hơn hoặc bằng 5 không',
  100000080:'Kiểm tra xem việc gọi các hàm mint() và burn() bởi người dùng ngẫu nhiên có bị từ chối không',
  100000081:'Kiểm tra xem việc gọi hàm burn() có cập nhật đúng totalSupply không',
  100000082:"Kiểm tra xem việc gọi hàm burnFrom() có cập nhật đúng hạn mức không",
  100000083:'Kiểm tra xem việc gọi hàm transfer() với người nhận giống như người gửi giao dịch có tăng số dư của người gửi không',
  100000084:'Kiểm tra xem việc gọi hàm transfer() với số lượng lớn hơn số dư có thất bại không',
  100000085:"Kiểm tra xem hạn mức của người chi tiêu có được cập nhật tương ứng sau khi gọi hàm transferFrom() không",
  100000086:"Kiểm tra xem việc gọi hàm transferFrom() có sử dụng số dư của người chi tiêu không",
  100000087:"Kiểm tra xem hạn mức có được cập nhật đúng sau khi gọi transferFrom(), hoặc giao dịch có bị hủy nếu số tiền không hợp lệ.",
  100000088:"Kiểm tra xem gọi hàm burnFrom() có cập nhật đúng totalSupply hay không.",
  100000089:'Kiểm tra xem quyền tạo token có tồn tại không',
  100000090:'Kiểm tra xem quyền đóng băng có tồn tại không',
  100000091:'Xem xét liệu siêu dữ liệu có thể được thay đổi không',
  100000092:'Nghiêm trọng',
  100000093:'Chính',
  100000094:'Trung bình',
  100000095:'Nhỏ',
  100000096:'Thông tin',
  100000097:'Quyền mint đã bị từ bỏ  ',
  100000098:'Quyền đóng băng đã bị từ bỏ  ',
  100000099:'Có thể thay đổi siêu dữ liệu của token  ',

  100000100:'Báo cáo hàng năm của bạn đang được tạo…',
  100000101:'Chào mừng bạn đến',
  100000102:'Đánh giá của bạn về năm 2024',
  100000103:'Tôi là người hướng dẫn cá nhân của bạn',
  100000104:'Ở đây để dẫn dắt bạn qua những dấu ấn hành trình của bạn trong năm 2024',
  100000105:'Mở báo cáo',
  100000106:'{num} ngày trước, bánh xe số phận đã bắt đầu chuyển động.',
  100000107:'{userName} Câu chuyện của chúng ta bắt đầu từ đây',
  100000108:'Cùng nhau, chúng ta đã chạy về phía một giấc mơ chung.',
  100000109:'Những Ngôi Sao Đầu Tư',
  100000110:'Tổng Quan Ví Hàng Năm - Tỷ Suất Lợi Nhuận Tổng',
  100000111:'Bạn đang dẫn đầu <em class="normal bold" style="color: #2AFF0A;">{percentage}</em> người dùng',
  100000112:'Trong năm qua, chúng tôi đã trải nghiệm <em class="normal bold" style="color: #FFF;">FOMO</em> do các biểu tượng mang lại và đã tận hưởng niềm vui của <em class="normal bold" style="color: #FFF;">meme tăng vọt</em>. Bây giờ, hãy cùng nhau bước vào những kỷ niệm của bạn.',
  100000113:'Nhà giao dịch ngôi sao',
  100000114:'Giao dịch tích lũy năm 2024 (lần)',
  100000115:'Số tiền giao dịch tích lũy($)',
  100000116:'Bạn đã vượt qua <em class="normal bold" style="color: #FFC72B;">{percentage}%</em> người dùng.',
  100000117:'Đây không chỉ là một thành tựu về mặt số liệu mà còn là biểu tượng của tầm nhìn và sự sáng suốt của bạn.',
  100000118:'Mỗi giao dịch là một bước tiến đến Web3.0.',
  100000119:'Ngôi sao đang lên',
  100000120:'Mức giảm lớn nhất của Bitcoin trong năm 2024 đạt<em class="normal">34%</em>，Sự điều chỉnh thị trường là điều bình thường, và hiệu suất đầu tư của bạn chỉ là một giai đoạn — tiềm năng lớn vẫn đang ở phía trước!',
  100000121:'Nhà Đầu Tư Kiên Định',
  100000122:'Mọi quan sát và chờ đợi đều là để chuẩn bị cho thời điểm chính xác hơn. Chúng tôi mong chờ được chứng kiến những kỳ tích đầu tư và lợi nhuận của bạn trong năm 2025.',
  100000123:'Token giao dịch nhiều nhất trong năm 2024',
  100000124:'Những gì bạn nắm giữ, sẽ vang vọng trở lại',
  100000125:'Sự tập trung và nỗ lực của bạn đã được thể hiện rõ ràng trong kết quả giao dịch của bạn.',
  100000126:'Hiệu Suất của Bitcoin trên SuperEx trong năm 2024',
  100000127:'Biến động giá Bitcoin của bạn trong năm 2024',
  100000128:'Xin chúc mừng vì đã gia tăng tài sản của bạn! Hãy duy trì đà phát triển trong năm tới.',
  100000129:'Trong năm 2024, bạn đã không nắm giữ Bitcoin.',
  100000130:'Nhà Đầu Tư Xuất Sắc',
  100000131:'Nhà Đầu Tư Kiên Định',
  100000132:'Nhà Đầu Tư Học Hỏi',
  100000133:'Dữ Liệu Giao Dịch Thị Trường Chính Của Bạn',
  100000134:'lợi nhuận($)',
  100000135:'Tỷ Suất Lợi Nhuận Hàng Năm (%)',
  100000136:'Xếp Hạng Lợi Nhuận (%)',
  100000137:'Dữ Liệu Giao Dịch Hợp Đồng Của Bạn',
  100000138:'Chiến lược giao dịch của bạn thể hiện sự sáng suốt của bạn — Cảm ơn bạn đã chọn hợp tác với chúng tôi!',
  100000139:'Ra Khơi Hướng Tới Tương Lai',
  100000140:'Bạn không chỉ theo kịp xu hướng mà còn là người tiên phong trong xu hướng! Bạn đã phát hành coin ở khu vực tự do <em class="normal bold" style="color: #FFF;">{num1}</em> lần và giao dịch <em class="normal bold" style="color: #FFF;">{num2}</em> lần. Bạn, người thích các sản phẩm sáng tạo, mới thực sự là một nhà phiêu lưu!',
  100000141:'Siêu Ngôi sao Mạng Xã hội',
  100000142:'Cảm ơn bạn đã mang đến <em class="normal bold" style="color: #FFF;">{num}</em> người dùng mới cho nền tảng của chúng tôi. Những giới thiệu của bạn đã thúc đẩy sự phát triển của chúng tôi. Chúng tôi mong chờ sẽ có thêm nhiều cá nhân cùng chí hướng gia nhập hành trình Web3.0 cùng chúng tôi.',
  100000143:'Ngôi sao Mạng xã hội đang toả sáng',
  100000144:'<em class="normal bold" style="color: #FFF;">{num}</em> người dùng của SuperEx đã kiếm được tới 40% hoa hồng giao dịch bằng cách mời bạn bè. Nếu bạn đã bỏ lỡ cơ hội trong năm 2024, đừng lo — hãy nắm bắt cơ hội trong năm 2025.',
  100000145:'Chia sẻ những điểm nổi bật trong năm của bạn với cộng đồng, khuyến khích thêm nhiều người tham gia cùng chúng tôi, và mở khóa những phần thưởng độc quyền khi bạn cùng nhau khám phá thế giới Crypto!',
  100000146:'Mời bạn bè để nhận phần thưởng trị giá 10 USDT!',
  100000147:'Chia sẻ Báo cáo',
  100000148:'Xem lại',
  100000149:'Trong năm 2024, bạn được biết đến trên SuperEx với Danh hiệu',
  100000150:'Bạn đã vượt trội hơn nhiều người dùng trên nền tảng:',
  100000151:'Thị trường chính Giao dịch giao ngay Lợi suất năm',
  100000152:'Hợp đồng Lợi suất năm',
  100000153:'Năm nay, tôi là một huyền thoại đầu tư!',
  100000154:'Mã giới thiệu: {InviteCode}',
  100000155:'SuperEx.com - Web3.0 sàn giao dịch tiền điện tử',
  100000156:'Chiến thắng đều đặn, sức mạnh được thể hiện!',
  100000157:'Kinh nghiệm năm nay đã có, năm sau sẽ còn tốt hơn nữa!',
  100000158:'Bạn có biết không?',
  100000159:'Khu vực tự do giao dịch giao ngay của SuperEx là nền tảng giao dịch Meme coin nóng nhất và có tiềm năng nhất trên thế giới.',
  100000160:'2024, SuperEx Thêm <em class="normal bold" style="color: #FFF;">{num}</em> Người Dùng, Như Một Gia Đình Mới',
  100000161:'Đánh giá 2024 của bạn và hành trình lợi nhuận gấp nghìn lần vào năm 2025 sẽ sớm bắt đầu.',
  100000162:'Đây là một bức thư từ một thành viên giàu kinh nghiệm của Superex, ghi lại những tin vui của họ trong năm 2024.',
  100000163:'@to*** đã thành công mua 1 BTC với 1 USDT, tỷ suất lợi nhuận lên tới <em class="normal bold" style="color: #FFF;font-size:0.7rem">9,958,800%</em>.',
  100000164:'@1o*** đã nhận được 1 ETH với 1 USDT, tỷ suất sinh lợi lên tới <em class="normal bold" style="color: #FFF;font-size:0.7rem">487,000%</em>.',
  100000165:'@we*** được 1 iPhone 15 với 1 USDT, tỷ suất lợi nhuận đạt <em class="normal bold" style="color: #FFF;font-size:0.7rem">92,800%</em>.',
  100000166:'Còn nhiều điều thú vị hơn nữa…',
  100000167:'Vốn nhỏ, lợi nhuận lớn và lối chơi không ngừng nâng cấp khiến mỗi lần tham gia đều tràn ngập bất ngờ!',
  100000168:'Giao ngay, hợp đồng, quản lý tài sản…',
  100000169:'Bức thư dài, chúng ta cùng tiếp tục đọc',
  100000170:'Tổng số token phát hành lần đầu <span class="inline-block relative bold" style="color: #FFFFFF;font-size:1rem">150+</span>,SuperEx sẽ tiếp tục nỗ lực để tạo ra nhiều cơ hội hơn cho người dùng.',
  100000171:'Tổng quan ví hàng năm Tài khoản lãi lỗ tích lũy',
  100000172:'Tổng quan ví Tài khoản Lãi lỗ hàng năm <em class="normal bold {classNum}">{num}</em>',
  100000173:'Bạn đang dẫn trước <em class="normal bold" style="color: #FFF;font-size:1rem">{percentage}%</em> người dùng. Sự khôn ngoan trong chiến lược đầu tư của bạn thật đáng kinh ngạc.',
  100000174:'2025-SuperEx',
  100000175:'Con đường đến tài sản',
  100000176:'Khi bạn sẵn sàng',
  100000177:'Chào bạn! Tôi là bạn mới của SuperEx.',
  100000178:'Tham gia SuperEx và khám phá những khả năng vô hạn. Đăng ký để nhận lợi ích cho người dùng mới.',
  100000179:'Người dùng @vb*** tham gia giao dịch trên sàn chính của thị trường giao ngay, tỷ suất lợi nhuận tích lũy của $ATOM gần <em class="normal bold" style="color: #FFF;font-size:0.7rem">10,400%</em>.',
  100000180:'Người dùng @xi*** tham gia giao dịch thị trường chính $PIPE Lợi suất tích lũy gần <em class="normal bold" style="color: #FFF;font-size:0.7rem">7,400%</em>.',
  100000181:'Người dùng @09*** tham gia giao dịch chính trên sàn $ATH với tỷ suất sinh lợi tích lũy gần <em class="normal bold" style="color: #FFF;font-size:0.7rem">3,500%</em>.',
  100000182:'Chúng tôi mong chờ được chứng kiến giao dịch đầu tiên của bạn trên sàn WEB3 và bắt đầu một chương thú vị!',
  100000183:'1USD、 Super Start、 1000+giao ngay, đòn bẩy 150X, chữ khắc 1000X…',
  100000184:'Trải nghiệm nhiều lĩnh vực có lợi suất cao!',
  100000185:'Tăng giảm chỉ là nhất thời, nhưng niềm tin trường tồn.',
  100000186:'Vượt qua biến động, chứng kiến giá trị thực sự.',
  100000187:'Báo cáo năm 2024 của bạn chưa được tạo. Chào mừng bạn đến với hành trình giao dịch năm mới! Tích lũy thêm các tương tác để mở khóa bản tóm tắt độc quyền của năm tới!',
  100000188:'Câu chuyện thường niên về tiền điện tử năm 2024 đang chờ bạn xem xét! Sống lại những khoảnh khắc nổi bật của năm 2024 với SuperEx, hãy đến và chia sẻ những khoảnh khắc độc quyền của bạn! ',
  100000189:'Câu chuyện thường niên về tiền điện tử năm 2024 đang chờ bạn xem xét!',
  100000190: 'Mở ứng dụng SuperEx để xem "Báo cáo thường niên"',
  100000191: '{year}Năm {month}Tháng {day}Ngày (UTC)',
  100000192: 'Người mua',
  100000193: 'Mã đơn hàng',
  100000194: 'Tôi',
  100000195: 'Danh sách người tham gia',
  100000196: 'Các mặt hàng tiền kỹ thuật số đã được phát hành. Vui lòng liên hệ với dịch vụ khách hàng để nhận các mặt hàng vật lý',
  100000197: 'Mua hàng thành công',
  100000198: '{name}đã được lấy thành công',
  100000199: 'Mua',
  100000200: 'Tất cả tải',
  100000201: 'Xin chúc mừng {name} đã chiến thắng {shop}!',
  100000202: 'Người dùng {name} đã tham gia {shop} thành công!'

}
export default vi


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/vi.js